import $api from "../../../axios"
import { IProjectDataRank } from "../types/projectDataRanks.types"

interface IGetProjectDataRanks {
  asin: string
  startDate: string
  endDate: string
  projectId: string
}

const projectsPath = "projects"
const getRanksData = async (params: IGetProjectDataRanks): Promise<IProjectDataRank[]> => {
  const response = await $api.get(projectsPath + "/project/ranks", { params })
  return response.data
}

export default {
  getRanksData,
}
